export const systemErrorMappings = {
    SYSTEM_INTERNAL_API_ERROR: {
        code: 'SYSTEM_INTERNAL_API_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Ocorreu um erro interno. Tente novamente em alguns instantes.',
            },
            {
                language: 'pt-BR',
                message: 'Ocorreu um erro interno. Tente novamente em alguns instantes.',
            },
            {
                language: 'en-US',
                message: 'An internal error occurred. Please try again in a few moments.',
            },
            {
                language: 'es-ES',
                message: 'Ocurrió un error interno. Intente nuevamente en unos momentos.',
            },
        ],
        technicalMessage: 'Ocorreu um erro interno durante a chamada da api',
        severity: 'error',
        critical: false,
    },
    SYSTEM_COREBANK_API_ERROR: {
        code: 'SYSTEM_COREBANK_API_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Erro ao conectar com o serviço bancário. Tente novamente.',
            },
            {
                language: 'pt-BR',
                message: 'Erro ao conectar com o serviço bancário. Tente novamente.',
            },
            {
                language: 'en-US',
                message: 'Error connecting to banking service. Please try again.',
            },
            {
                language: 'es-ES',
                message: 'Error al conectar con el servicio bancario. Intente nuevamente.',
            },
        ],
        technicalMessage: 'Error in corebank api',
        severity: 'error',
        critical: false,
    },
    SYSTEM_TOKEN_ERROR: {
        code: 'SYSTEM_TOKEN_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Erro ao autenticar. Tente novamente.',
            },
            {
                language: 'pt-BR',
                message: 'Erro ao autenticar. Tente novamente.',
            },
            {
                language: 'en-US',
                message: 'Authentication error. Please try again.',
            },
            {
                language: 'es-ES',
                message: 'Error de autenticación. Intente nuevamente.',
            },
        ],
        technicalMessage: 'Falha ao obter o access token',
        severity: 'error',
        critical: false,
    },
    NOT_FOUND_PDF: {
        code: 'NOT_FOUND_PDF',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'PDF não encontrado.',
            },
            {
                language: 'pt-BR',
                message: 'PDF não encontrado.',
            },
            {
                language: 'en-US',
                message: 'PDF not found.',
            },
            {
                language: 'es-ES',
                message: 'PDF no encontrado.',
            },
        ],
        technicalMessage: 'PDF não encontrado!',
        severity: 'error',
        critical: false,
    },
};
